import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'shabic-icon-empty-orders',
  templateUrl: './icon-empty-orders.component.html',
  styleUrls: ['./icon-empty-orders.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconEmptyOrdersComponent {}
